import styled from "styled-components";

const Button = styled.button`
  font-family: inherit;
  font-size: 1.2rem;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
  height: 4rem;
  padding: 1.3rem;
  display: flex;
  align-items: center;
`;

export default Button;
